"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _router = require("next/router");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TenantContext = require("../context/TenantContext");
var _removeUndefinedEntries = _interopRequireDefault(require("../utils/removeUndefinedEntries"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _Formed = _interopRequireDefault(require("./Formed"));
var _SearchBar = _interopRequireDefault(require("./SearchBar"));
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const HeroSearchBar = ({
  initialValues,
  hasHero
}) => {
  const {
    push
  } = (0, _router.useRouter)();
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  if (brandConfig.searchBar?.hide) {
    return null;
  }
  return __jsx(_Formed.default, {
    skipPrompt: true,
    initialValues: initialValues,
    handleSubmit: async ({
      accommodationType,
      booking: newBooking
    }) => {
      await push({
        pathname: `/search`,
        query: (0, _removeUndefinedEntries.default)(_objectSpread(_objectSpread({}, newBooking), {}, {
          accommodationType: accommodationType === 'all' ? undefined : accommodationType
        }))
      });
    }
  }, () => __jsx(SearchBarContainer, {
    className: "hero-searchbar-container"
  }, __jsx(_ContentWrapper.default, {
    variant: hasHero ? 'searchList' : undefined
  }, __jsx(_SearchBar.default, {
    hideSearchIcon: true,
    active: brandConfig.searchBar?.active ?? ['tripgroup', 'datepicker', 'accommodationType'],
    variant: "hero"
  }))));
};
var _default = exports.default = HeroSearchBar;
const SearchBarContainer = _styledComponents.default.div.withConfig({
  displayName: "HeroSearchBar__SearchBarContainer",
  componentId: "sc-1gwxexr-0"
})(["top:4rem;width:100%;position:absolute;"]);